import { FileSpreadsheet, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "./StatusBadge";
import { useAuth } from "@/context/AuthContext";
import { fmtNum, fmtDate } from "@/lib/api";
import { exportExcel, exportPDF } from "@/lib/export";

// cols: [{k, label, type: "money"|"text"|"date"|"badge"}]
export function SimpleTable({ title, cols, rows, testId, module, totals = true }) {
  const { meta, can } = useAuth();
  const show = (c, r) => (c.type === "money" ? fmtNum(r[c.k]) : c.type === "date" ? fmtDate(r[c.k]) : c.type === "badge" ? <StatusBadge value={r[c.k]} /> : r[c.k] ?? "—");
  const ex = cols.filter((c) => c.type !== "badge").map((c) => ({ label: c.label, raw: (r) => (c.type === "money" ? Number(r[c.k] || 0) : r[c.k] ?? "") }));
  return (
    <div className="bg-card border rounded-lg">
      <div className="p-3 border-b flex items-center gap-2">
        <h3 className="text-xs font-bold uppercase tracking-wider flex-1">{title}</h3>
        {(!module || can(module, "exporter")) && rows.length > 0 && (
          <>
            <Button variant="outline" size="sm" onClick={() => exportExcel(title, ex, rows)} data-testid={`${testId}-excel`}><FileSpreadsheet className="h-4 w-4" /></Button>
            <Button variant="outline" size="sm" onClick={() => exportPDF(title, ex, rows, { company: meta.settings?.nom_entreprise })} data-testid={`${testId}-pdf`}><FileText className="h-4 w-4" /></Button>
          </>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs" data-testid={testId}>
          <thead className="bg-muted/60 text-[10px] uppercase tracking-wider text-muted-foreground">
            <tr>{cols.map((c) => <th key={c.k} className={`px-3 py-2.5 whitespace-nowrap ${c.type === "money" ? "text-right" : "text-left"}`}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id || r.cle || i} className={`border-t ${r.niveau === "ecart" ? "bg-red-50" : ""}`}>
                {cols.map((c) => <td key={c.k} className={`px-3 py-2 whitespace-nowrap ${c.type === "money" ? `text-right font-mono ${Number(r[c.k]) < 0 ? "text-primary" : ""}` : ""}`}>{show(c, r)}</td>)}
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={cols.length} className="py-10 text-center text-muted-foreground">Aucune donnée</td></tr>}
          </tbody>
          {totals && rows.length > 0 && (
            <tfoot className="border-t-2 border-foreground/80 bg-muted/40 font-semibold">
              <tr>{cols.map((c, i) => <td key={c.k} className={`px-3 py-2 ${c.type === "money" ? "text-right font-mono" : ""}`}>{i === 0 ? "Total" : c.type === "money" ? fmtNum(rows.reduce((s, r) => s + Number(r[c.k] || 0), 0)) : ""}</td>)}</tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
